var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { LookupValueRequest, OrderByEnum } from "../../../../models/lookups/lookup.models";
import { LookupValueQuery } from "../../../../models/lookups/lookup.models";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { BrandClientService } from "../../../../services/modules/brand-client.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { LotteryPlatformClaims } from "../../../../constants/modules/lotteryplatform.claims";
var InsuranceAccountPage = /** @class */ (function () {
    function InsuranceAccountPage(lookupService, brandClientService, notificationService, userClaimsService) {
        this.lookupService = lookupService;
        this.brandClientService = brandClientService;
        this.notificationService = notificationService;
        this.userClaimsService = userClaimsService;
        this.operators = [];
        this.brands = [];
        this.insuranceAccounts = [];
        this.selectedInsuranceAccountId = null;
    }
    InsuranceAccountPage.prototype.canActivate = function () {
        return this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewInsuranceAccount)
            || this.userClaimsService.hasPermission(LotteryPlatformClaims.EditInsuranceAccount);
    };
    Object.defineProperty(InsuranceAccountPage.prototype, "canEdit", {
        get: function () {
            return this.userClaimsService.hasPermission(LotteryPlatformClaims.EditInsuranceAccount);
        },
        enumerable: false,
        configurable: true
    });
    InsuranceAccountPage.prototype.attached = function () {
        var _this = this;
        this.loadOperators();
        this.brandClientService.getInsuranceAccounts().then(function (x) {
            _this.insuranceAccounts = x;
        });
    };
    InsuranceAccountPage.prototype.loadOperators = function () {
        var _this = this;
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.operators;
        request.setOverrideMetaDataFiltering(OrderByEnum.NameASC);
        this.lookupService.getLookup(request).then(function (x) {
            _this.operators = x.values;
        });
    };
    InsuranceAccountPage.prototype.onOperatorSelected = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            var _this = this;
            return __generator(this, function (_a) {
                this.selectedOperator = event.detail.item;
                this.selectedBrand = null;
                this.selectedInsuranceAccountId = null;
                this.brands = [];
                if (!this.selectedOperator)
                    return [2 /*return*/];
                request = new LookupValueRequest();
                request.lookupValueQuery = LookupValueQuery.brands;
                request.filterByIsActive = false;
                request.setOverrideMetaDataFiltering(OrderByEnum.NameASC);
                request.parameters = this.selectedOperator.id.toString();
                this.lookupService.getLookup(request).then(function (x) {
                    _this.brands = x.values;
                });
                return [2 /*return*/];
            });
        });
    };
    InsuranceAccountPage.prototype.onBrandSelected = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.selectedBrand = event.detail.item;
                        this.selectedInsuranceAccountId = null;
                        if (!this.selectedBrand)
                            return [2 /*return*/];
                        _a = this;
                        return [4 /*yield*/, this.brandClientService.getBrandInsuranceAccountId(this.selectedBrand.id)];
                    case 1:
                        _a.selectedInsuranceAccountId = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InsuranceAccountPage.prototype.onInsuranceAccountChanged = function (event, insuranceAccountId) {
        return __awaiter(this, void 0, void 0, function () {
            var previous, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (event.detail.value !== true)
                            return [2 /*return*/];
                        if (!this.selectedBrand)
                            return [2 /*return*/];
                        previous = this.selectedInsuranceAccountId;
                        this.selectedInsuranceAccountId = insuranceAccountId;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.brandClientService.setInsuranceAccount(this.selectedBrand.id, insuranceAccountId)];
                    case 2:
                        _b.sent();
                        this.notificationService.show("Insurance Account", "Insurance account updated", NotificationType.Success);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this.selectedInsuranceAccountId = previous;
                        this.notificationService.show("Insurance Account", "Failed to update insurance account", NotificationType.Error);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    InsuranceAccountPage = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [LookupClientService,
            BrandClientService,
            NotificationClientService,
            UserClaimsService])
    ], InsuranceAccountPage);
    return InsuranceAccountPage;
}());
export { InsuranceAccountPage };
